import React, {Component, useContext, useEffect, useState} from 'react';
import ReactDOM from 'react-dom';
import { Button, ButtonCancel, ButtonModify, ButtonProceed, ButtonReturn } from '../../components/buttons';
import { Layout, MinMaxLayout, SeventyThirtyLayout, SixtyFourtyLayout } from '../../layouts';
import Welcome from '../../layouts/welcome';
import Row from '../../components/row';
import Container from '../../layouts/containers/container';
import ActivityItemNew from '../../components/activity/activity-item-new';
import List from '../../components/list';
import InputsDropdown from '../../components/inputs/inputs-dropdown';
import SearchBar from '../../components/searchbar';
import ContainerTable from '../../layouts/containers/container-table';
import { stringToFriendlyDatetime } from '../../lib/helpers/datetime-helpers';
import ContainerIndex from '../../layouts/containers/container-index';
import ThemeContext from '../../context/context-theme';
import Grid from '../../components/grid';
import InputsCheckbox from '../../components/inputs/inputs-checkbox';
import LabelContainer from '../../components/label-container';
import Divider from '../../components/divider/divider';
import Blurred from '../../components/blurred';
import InputsCounter from '../../components/inputs/inputs-counter';
import DateTimeInput from '../../components/inputs/date-time-input';
import meetingsApi from '../../lib/meetings/meetings-api';
import ErrorContainer from '../../components/error-container';
import InputsText from '../../components/inputs/inputs-text';
import MediaHelper from '../../lib/helpers/media';
import _ from 'lodash';
import PopupsAdditionalPackageDetails from '../bookings/popups/popups-additional-package-details';
import PopupContext from '../../context/context-popup';
import companiesApi from '../../lib/companies/companies-api';
import BillingDetails from '../../components/billing-profile';

const Package = ({ room, onAddonChange, onAdditionalDetailsAdd, booking, addon, index, error = null, packageItem, data, onAddonQuantityChange }) => {
    const { setPopup } = useContext(PopupContext);

    const showAdditionalRequirements = () => {
        setPopup(<PopupsAdditionalPackageDetails edit={true} onAddonChange={onAddonChange} data={data} onSuccess={onAdditionalDetailsAdd} booking={booking} addon={addon} addonPackage={packageItem}/>);
    }

    return (
        <Blurred toggled={false}>
            <ErrorContainer errors={error}>
                <div className="package" id={`package-${index}`}>
                    <div className="package__details">
                        <div className="package-details__top">
                            <InputsCheckbox
                                checked={data !== undefined}
                                square={true}
                                className="package__checkbox"
                                onChange={e => {
                                    onAddonQuantityChange(packageItem.id, e.value ? 1 : 0)
                                }}
                            />
                            <p>{ packageItem?.name }</p>
                        </div>
                        <List gap="20px">
                            { packageItem?.package_description?.length > 0 && <p className="package-details__description" dangerouslySetInnerHTML={{ __html: packageItem?.package_description }}></p> }
                            { addon?.show_additional_requirements_field && 
                                <Blurred toggled={data === undefined}>
                                    <ButtonModify onClick={showAdditionalRequirements}>{ addon?.additional_requirements_label || 'Additional Requirements' }</ButtonModify> 
                                </Blurred>
                            }
                        </List>
                    </div>
                    <div className="package__amount">
                        <p>£{ packageItem?.price_per_person } Per Person</p>

                        <InputsCounter
                            value={data?.quantity}
                            max={room?.max_attendees}
                            onChange={number => {
                                onAddonQuantityChange(packageItem.id, number)
                            }}
                        />
                    </div>
                </div>
            </ErrorContainer>
        </Blurred>
    )
}

const Addons = ({ 
    booking, 
    errors = {}, 
    room,
    addonsValues = [], 
    addonsAllowed = [],
    onAddonQuantityChange,
    onAddonChange, 
    onAdditionalDetailsAdd, 
}) => {
    const getPackageBooking = (id) => addonsValues.find(a => a.id === id);
    const getPackageError = (packageId) => errors?.[packageId];

    const addonsIds = addonsValues?.map(a => a.id);

    const addonsToShow = addonsAllowed;

    return (
        <Container>
            <Container.Header>
                <Container.Text color="#FF6933" fontSize="18px">Addons</Container.Text>
            </Container.Header>

            <Container.Content>
            <Blurred toggled={booking?.start === undefined}>
                <List gap="40px">
                        { Object.values(addonsToShow || [])?.map((addon, index) => {
                            const packageIds = addon?.add_on_packages?.map(p => p.id);

                            return (
                                <Container key={index}>
                                    <Container.Header>
                                        <List gap="20px">
                                            <Container.Text color="#24191F" fontSize="20px">{ addon?.name }</Container.Text>
                                            <Container.Text color="#929BA8" fontSize="14px">Choose from one of our catering packages below to enhance your meeting experience for you and your guests. Dietary requirements will be collected after your booking is confirmed.</Container.Text>
                                        </List>
                                    </Container.Header>
                        
                                    <Container.Content>
                                        <List gap="80px">
                                            { addon?.add_on_packages?.map((packageData, index) => {
                                                const data = getPackageBooking(packageData.id);
                                                const error = getPackageError(packageData.id);

                                                const hasAPackageFromThisAddon = addonsIds?.some(id => packageIds.includes(id));
                                                
                                                let toggled = false;

                                                if (hasAPackageFromThisAddon && addon.allow_multiple_add_on_bookings === false) {
                                                    toggled = addonsIds.includes(packageData.id) === false ? true : false;
                                                }

                                                return <Blurred toggled={toggled}>
                                                    <Package 
                                                        key={index} 
                                                        packageItem={packageData} 
                                                        data={data}
                                                        error={error}
                                                        index={index}
                                                        addon={addon}
                                                        booking={booking}
                                                        room={room}
                                                        onAddonChange={onAddonChange}
                                                        onAdditionalDetailsAdd={onAdditionalDetailsAdd}
                                                        onAddonQuantityChange={onAddonQuantityChange}
                                                    />
                                                </Blurred>
                                            } )}
                                        </List>
                                    </Container.Content>
                                </Container>
                            )
                        }) }
                </List>
                </Blurred>
            </Container.Content>
        </Container>
    )
}


const Summary = ({
    addons = [],
    addonsValues = [],
    costs = null,
}) => {
    const addonPackages = addons?.flatMap((addon) => addon?.add_on_packages);
    const getPricing = (id) => costs?.addons_pricing?.find((a) => a.id === id)?.price;

    const data = addonsValues?.map((val) => {
        const addonName = addonPackages.find(({ id }) => id === val.id)?.name;

        return [
            val?.quantity || 0,
            addonName || 'No Name',
            `£${getPricing(val.id) || 0}`
        ]
    });

    let price = costs?.total_credits_used > 0 ? `${costs.total_credits_used} credit(s)` : `£${costs?.meeting_room_price_less_credits}`;

    if (costs?.total_credits_used > 0 && costs?.meeting_room_price_less_credits > 0) {
        price = `£${costs?.meeting_room_price_less_credits} + ${costs?.total_credits_used} credit(s)`;
    }

    if (costs !== null) {
        data.unshift([
            1,
            'Meeting Room Booking',
            price,
        ])
    }

    return (
        <ContainerTable
            showMobileColumns
            headerColor="rgb(146, 155, 168)"
            valueColor="black"
            className="table-bookings"
            columns={[
                { field: 'QTY', width: '25%' },
                { field: 'Item', width: '50%' },
                { field: 'Price/Credit(s)', width: '25%' },
            ]}
            data={[
                ...data
            ]}
        />
    )
}

class MeetingsBooking extends Component {
    constructor(props) {
        super(props);

        this.state = {
            room: null,
            agree: false,
            errors: {},
            costs: null,
            params: {
                meeting_room_id: this.props.id,
                booker_type: 'App\\Models\\User',
                booker_id: window.user.id,
                no_attendees: 1,
            }
        }
    }

    componentDidMount() {
        this.fetchMeetingRoom();
    }

    checkQueryParams() {
        const searchParams = new URLSearchParams(window.location.search);

        const no_attendees = searchParams.get('no_attendees');
        const duration_mins = searchParams.get('duration_mins');
        const start = searchParams.get('start');

        this.onMultipleChange({
            no_attendees: no_attendees ? Number.parseInt(no_attendees) : 1,
            duration_mins: duration_mins ? Number.parseInt(duration_mins) : undefined,
            start: start ? start : undefined,
        }, () => {
            if (no_attendees && duration_mins && start) {
                this.getBookingCosts();
            }
        });
    }

    onChange(e, callback = () => {}) {
        const { name, value } = e.target;
        const params = { ...this.state.params }

        params[name] = value;

        this.setState({ params }, () => {
            callback();

            if (name === 'no_attendees') {
                this.getBookingCosts();
            }
        })
    }

    fetchMeetingRoom() {
        meetingsApi.getMeetingRoom(this.props.id).then(({ data }) => {
            this.setState({ room: data }, () => {
                this.checkQueryParams();
            });
        });
    }

    hasAddonErrors() {
        return Object.keys(this.state.costs?.errors || {}).length > 0;
    }

    getBookingCosts = _.debounce(() => {
        meetingsApi.getBookingQuote(this.state.params).then(({ data }) => {
            this.setState({ costs: data });
        });
    }, 500, false);

    createBooking() {
        meetingsApi.createMeetingRoomBooking(this.state.params, (errors) => {
            this.checkErrors(errors);
        }).then((data) => {
            window.location.href = `/mydmc/bookings/${data.id}`
        });
    }

    checkErrors(errors) {
        this.setState({ errors });

        const errorsMap = Object.keys(errors?.addons || {})
            ?.map((key) => document.getElementById(`package-${key}`))
            ?.filter(err => err !== null)

        if (errorsMap?.length > 0) {
            return errorsMap?.[0]?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }

        if (errors?.booker_id !== undefined) {
            const details = document.querySelector('.billing-details');

            if (details) details.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    onMultipleChange(e, callback = () => {}) {
        let params = { ...this.state.params }

        params = {
            ...params,
            ...e
        }

        this.setState({ params }, callback);
    }

    onStartChange({ start, duration}) {
        const date = dayjs(`${start.date} ${duration.start}`).utc();

        this.onMultipleChange({
            start: date,
            duration_mins: duration?.duration_mins,
        }, () => {
            this.getBookingCosts();
        })
    }

    onAttendeesChange(value) {
        if (value <= this.state.room?.max_attendees) {
            this.onChange({
                target: { name: 'no_attendees', value }
            })
        }
    }

    onAddonQuantityChange(id, number) {
        if (number < 0) return;

        this.onAddonChange(id, {
            target: {
                name: 'quantity',
                value: number
            }
        });

        if (number <= 0) this.removeAddonFromArray(id);
    }

    onAddonChange(id, e) {
        const { name, value } = e.target;
        const addons = this.state.params?.addons !== undefined ? [ ...this.state.params.addons ] : []

        const addon = addons.find(a => a.id === id);

        if (addon) {
            addon[name] = value
        } else {
            let data = {
                id: id,
                quantity: 0,
                [name]: value,
            }

            addons.push(data);
        }

        this.onChange({
            target: {
                name: 'addons',
                value: addons
            }
        }, () => {
            this.getBookingCosts();
        });
    }

    onAddonChangeWithoutCosts(id, e) {
        const { name, value } = e.target;
        const addons = this.state.params?.addons !== undefined ? [ ...this.state.params.addons ] : []

        const addon = addons.find(a => a.id === id);

        if (addon) {
            addon[name] = value
        } else {
            let data = {
                id: id,
                quantity: null,
                [name]: value,
            }

            addons.push(data);
        }

        this.onChange({
            target: {
                name: 'addons',
                value: addons
            }
        });
    }

    removeAddonFromArray(id) {
        let addons = this.state.params?.addons !== undefined ? [ ...this.state.params.addons ] : []

        addons = addons.filter(a => a.id !== id);

        this.onChange({
            target: {
                name: 'addons',
                value: addons
            }
        });
    }

    getFeaturedImage() {
        const image = this.state.room?.content?.room_feature_image?.[0];

        if (image?.file_name === undefined) return '';

        return MediaHelper.formatPublicPath(`/images/${image?.file_name}`);
    }

    getAddonsFromPackages() {
        const addons = this.state.room?.add_on_packages?.reduce((accumulator, currentObject) => {
            const groupId = currentObject.add_on_category.id;
        
            if (!accumulator[groupId]) {
                accumulator[groupId] = {
                    ...currentObject.add_on_category,
                    add_on_packages: [currentObject],
                };
            } else {
                accumulator[groupId].add_on_packages.push(currentObject);
            }
    
            return accumulator;
        }, {}) || [];

        return addons;
    }

    getLocation() {
        const { name, address_one, address_two, address_post_code, address_city } = this.state.room?.office_building || {
            name: '',
            address_one: '',
            address_two: '',
            address_post_code: '',
            address_city: ''
        };

        let string = [
            name,
            address_one,
            address_two,
            address_post_code,
            address_city
        ].filter(e => e !== undefined && e !== null);

        return string.join(', ');
    }

    bookDisabled() {
        if (this.state.params?.no_attendees === 0) return true;
        if (this.state.params?.start === null || this.state.params?.start === undefined) return true;

        if (this.state.agree === true) return false;

        return true;
    }

    render() {
        if (this.state.room === null) return null;

        const featuredImage = this.getFeaturedImage();
        const location = this.getLocation();

        const canBook = this.bookDisabled();

        return (
            <Layout 
            theme="light"
            topLeft={<Welcome title="Booking: Section Name" subtitle={this.state.room?.name}/>}
            topRight={
                <Row gap="20px">
                    <ButtonReturn responsive onClick={() => window.location.href = `/mydmc/meeting-rooms/${this.state.room.id}`}>Cancel</ButtonReturn>
                </Row>
            }
        >
            <MinMaxLayout
                main={
                    <div className="booking-view">
                        <List gap="40px" className="booking-view__child">
                            <Container>
                                <Container.Header>
                                    <Container.Text color="#FF6933" fontSize="18px">Confirm Details</Container.Text>
                                </Container.Header>

                                <Container.Content> 
                                    <List gap="40px">
                                        <div className="booking-view__image" style={{ backgroundImage: `url('${featuredImage}')` }}></div>

                                        <InputsText
                                            label="Meeting Name (This is publicly viewable)"
                                            value={this.state.params?.name}
                                            onChange={this.onChange.bind(this)}
                                            name="name"
                                            placeholder="Enter Here"
                                        />

                                        <LabelContainer label='Booking Type'>
                                            { this.state.room?.name }
                                        </LabelContainer>

                                        <LabelContainer label='Booking Location'>
                                            { location }
                                        </LabelContainer>

                                        <LabelContainer label="Booking Date & Duration">
                                            <ErrorContainer errors={this.state.errors?.start}>
                                                <DateTimeInput
                                                    onChange={this.onStartChange.bind(this)}
                                                    value={[
                                                        this.state.params?.start,
                                                        this.state.params?.duration_mins
                                                    ]}
                                                    room={this.state.params}
                                                />
                                            </ErrorContainer>
                                        </LabelContainer>
                                        
                                        <Blurred toggled={this.state.params?.start === undefined}>
                                            <InputsCounter
                                                label="Number Of Attendees"
                                                min={0}
                                                max={this.state.room?.max_attendees}
                                                onChange={this.onAttendeesChange.bind(this)}
                                                value={this.state.params?.no_attendees}
                                                errors={this.state.errors?.no_attendees}
                                            />
                                        </Blurred>
                                    </List>
                                </Container.Content>
                            </Container>

                            <Addons 
                                addonsAllowed={this.getAddonsFromPackages()}
                                addonsValues={this.state.params?.addons}
                                onAddonQuantityChange={this.onAddonQuantityChange.bind(this)}
                                errors={this.state.costs?.errors?.addons}
                                onAdditionalDetailsAdd={() => {}}
                                booking={this.state.params}
                                room={this.state.room}
                                onAddonChange={this.onAddonChangeWithoutCosts.bind(this)}
                            />

                            <ErrorContainer errors={this.state.errors?.booker_id !== undefined ? ['You have not setup a billing profile yet'] : null}>
                                <BillingDetails/>
                            </ErrorContainer>
                        </List>

                        <Container className="booking-view__child">
                            <Container.Header>
                                <Container.Text color="#FF6933" fontSize="18px">Summary</Container.Text>
                            </Container.Header>

                            <Container.Content>
                                <List gap="40px">
                                    <Summary
                                        addons={Object.values(this.getAddonsFromPackages())}
                                        addonsValues={this.state.params?.addons}
                                        costs={this.state.costs}
                                    />

                                    <div className="agree-box" style={{ padding: '0px', gap: '0px' }}>
                                        <div class="bac-bar">
                                            <p style={{ fontSize: '14px' }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                                    <path id="Path_689" data-name="Path 689" d="M12,22A10,10,0,1,1,22,12,10,10,0,0,1,12,22ZM11,11v6h2V11Zm0-4V9h2V7Z" transform="translate(-2 -2)" fill="#fcfcfc"/>
                                                </svg>
                                                <b>Payment via BACS only</b> or using your <b>Membership Credits</b> (If Available)
                                            </p>
                                        </div>

                                        <div className="agree-box__inner">
                                            <InputsCheckbox
                                                text={<div>I have read and agree to the <a href="/booking-terms-and-conditions" style={{ color: 'white' }}>booking terms and conditions</a></div>}
                                                checked={this.state.agree}
                                                onChange={(e) => this.setState({ agree: e.value })}
                                            />
                                            <div className="agree-box__content">
                                                <div className="agree-box__details">
                                                    <List gap="5px">
                                                        { this.state.costs?.total_credits_available !== undefined ? this.state?.room?.disable_credits_usage === false ? 
                                                            <Container.Text fontSize="16px">{ this.state.costs?.total_credits_available || 0} credits available</Container.Text> :
                                                            <Container.Text fontSize="16px">Credits can not be used with this room</Container.Text> : ''
                                                        }
                                                        { this.state?.room?.disable_credits_usage === false && <div className="agree-box-details__detail">
                                                            <p>Credits Due</p>
                                                            <span>{ this.state?.costs?.total_credits_used || 0 }</span>
                                                        </div> }
                                                    </List>
                                                    <div className="agree-box-details__detail">
                                                        <p>BACS Due</p>
                                                        <span>£{ this.state?.costs?.total || 0 }</span>
                                                    </div>
                                                </div>

                                                <Blurred toggled={canBook}>
                                                    <ButtonModify onClick={this.createBooking.bind(this)}>Complete your booking</ButtonModify>
                                                </Blurred>
                                            </div>
                                        </div>
                                    </div>

                                    <Container>
                                        <Container.Header>
                                            <Container.Text fontSize="18px" color="#FF6933">Booking Information</Container.Text>
                                        </Container.Header>

                                        <Container.Content>
                                            <Container.Text fontSize="14px" color="#24191F" html={this.state.room?.booking_information}></Container.Text>
                                        </Container.Content>
                                    </Container>

                                    <Container>
                                        <Container.Header>
                                            <Container.Text fontSize="18px" color="#FF6933">Booking Terms</Container.Text>
                                        </Container.Header>

                                        <Container.Content>
                                            <Container.Text fontSize="14px" color="#24191F" html={ this.state.room?.booking_terms }></Container.Text>
                                        </Container.Content>
                                    </Container>
                                                    
                                    <Container>
                                        <Container.Header>
                                            <Container.Text fontSize="18px" color="#FF6933">Contact Us</Container.Text>
                                        </Container.Header>

                                        <Container.Content>
                                            <Container.Text fontSize="14px" color="#24191F">
                                                +44 (0)1226 720 700

                                                bookings@barnsleydmc.co.uk

                                                DMC
                                                County Way
                                                Barnsley
                                                S70 2JW
                                                UK
                                            </Container.Text>
                                        </Container.Content>
                                    </Container>
                                </List>
                            </Container.Content>
                        </Container>
                    </div>
                }
            />
        </Layout>    
        )
    }
}

const el = document.getElementById('meetings-booking');

if (el) {
    ReactDOM.render(<MeetingsBooking id={el.getAttribute('data-id')}/> , el);
}
